// extracted by mini-css-extract-plugin
export default {"backToCoreButton":"BackToCoreButton_backToCoreButton__uo9Hs"};